import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackAddressCreatedParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/account/trackAddressCreated";

const useTrackAddressCreated = (
    parameters: TrackAddressCreatedParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.addressCreated, parameters, options);
};

export default useTrackAddressCreated;
